import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=420a962c&"
import script from "./UserPermissions.js?vue&type=script&lang=js&"
export * from "./UserPermissions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports